import { render, staticRenderFns } from "./Unauthorized.vue?vue&type=template&id=710805e6"
import script from "./Unauthorized.vue?vue&type=script&lang=ts"
export * from "./Unauthorized.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports